<template>
    <div class="forex-page commo-indices-page var_ind">

        <BannerPages
            :title="'indices.titleBanner'"
            :descriptions="[
                $t('indices.descriptionBanner1'),
                $t('indices.descriptionBanner2')
            ]"
            :img="'/images/indices/2.Indices-Img1.png'"
            mainImageWidthDesk="593"
            mainImageHeightDesk="563"
            alt="Trade the global equity markets with Tradeview Europe"
            :buttons="[
                {
                    type: 'external',
                    href: getExternalUrl('/register/1/live-account'),
                    class: 'primary-button-medium',
                    text: 'indices.btn1' 
                },
                {
                    type: 'external',
                    href: getExternalUrl('/register/1/demo-account'),
                    class: 'second-button-medium-white',
                    text: 'indices.btn2' 
                }
            ]"
        />

        <div class="margin-general find_forex margin-less">
            <div class="text">
                <h2>{{ $t("indices.find_indices_title") }}</h2>
                <p class="body-4 desc1">{{ $t("indices.find_indices_desc1") }}</p>
            </div>
            <LazyTabsPlatforms :tabs="tabs" :categories="categories" buttonLabelKey="indices.btn" />
        </div>

        <LazyToStarMam 
            class="rigth_position none_img"
            :title="$t('indices.firstStart.title')"
            :itemsList="firstItemsList"
            :style="degrade"
        />

        <LazyPlatformSlider
            titleSection="commodities.platfor_slide.title"
            descriptionSection="commodities.platfor_slide.desc"
            :slider="slider"
            :slidesPerView="1"
            :spaceBetween="20"
            className="slideX3"
            :style="degrade2"
        />

        <LazyMoreResource
            :titleH2="'commodities.protectedTitle'"
            :cards="cardsSlideProtected"
            :padding="'padding-icon'"
            class="protected with-icons"
        />

        <client-only>
            <LazyInvestment
                :label="'indices.ready'"
                :buttonConfigs="[
                    {
                        type: 'external',
                        href: getExternalUrl('/register/1/live-account'),
                        class: 'primary-button-medium',
                        textKey: 'indices.btn-invest'
                    }
                ]"
            />
        </client-only>

    </div>
</template>
  
<script setup>
// import PreloaderPage from "~/components/PreloaderPage.vue";
import LazyTabsPlatforms from "~/components/forex/TabsPlatforms";
import LazyToStarMam from "~/components/services/multi_mam/ToStarMam.vue";
import LazyPlatformSlider from "~/components/forex/PlatformsSlider.vue";
import LazyMoreResource from "~/components/home/MoreResource";
import LazyInvestment from "~/components/Investment";
// import '~/assets/scss/pages/forex.scss';

import { useI18n } from "vue-i18n";
import { useExternalUrl } from '@/composables/useExternalUrl';
import { useImage } from '#imports';

const { t, locale } = useI18n();
const { getExternalUrl } = useExternalUrl();
const { $regulationsVar } = useNuxtApp();

const regulation = ref($regulationsVar.getRegulation(locale.value));
const nuxtImg = useImage();

const title = t("seo.indices.title");
const description = t("seo.indices.description");
const imgSeo = 'https://tradeview.eu/images/seo/23Indices.jpg'

useSeoMeta({
    title: title,
    ogTitle: title,
    twitterTitle: title,
    description: description,
    ogDescription: description,
    twitterDescription: description,
    ogImage: imgSeo,
    twitterImage: imgSeo
});

const degradadeImageUrl = '/images/commodities/3.Commodities-Gradient1.avif';
const degradade2ImageUrl = '/images/commodities/6.Commodities-Gradient3.avif';

const optimizedDegrade = nuxtImg(degradadeImageUrl, {
  quality: 50,
  format: 'avif',
});
const optimizedDegrade2 = nuxtImg(degradade2ImageUrl , {
  quality: 50,
  format: 'avif',
});

const degrade = computed(() => {
  return {
    '--degrade': `url('${optimizedDegrade}')`,
  };
});

const degrade2 = computed(() => {
  return {
    '--degrade2': `url('${optimizedDegrade2}')`,
  };
});

let tabs = ref([
    { value: "indices", label: "" }
]);

let categories = ref({
    indices: [
        {
        title: "indices.indicesTitle",
        description: "indices.indicesDesc",
        text: {
            title: "indices.indicesTitleText",
            desc: "indices.indicesTitleDesc",
        },
        buttonText: "indices.btn",
        subtitles: [
            "indices.list-products.subtitle",
            "indices.list-products.subtitle2"
        ],
        commoditiesItems: [
            ["indices.list-products.item1", "indices.list-products.item9"],
            ["indices.list-products.item2", "indices.list-products.item10"],
            ["indices.list-products.item3", "indices.list-products.item11"],
            ["indices.list-products.item4", "indices.list-products.item12"],
            ["indices.list-products.item5", "indices.list-products.item13"],
            ["indices.list-products.item6", "indices.list-products.item14"],
            ["indices.list-products.item7", "indices.list-products.item15"],
            ["indices.list-products.item8", "indices.list-products.item16"]
        ]
        },
    ],
});

const firstItemsList = ref([
    {
        type: 'paragraph',
        content: [
            { text: t("indices.firstStart.item1"), strong: false },
        ]
    }
]);

let slider = ref([
    /* {
        imgBackground: "/images/forex/backgound-mt4.png",
        title: "forex.mt4",
        description: [
            "commodities.platfor_slide.metatrader4Desc1",
            "commodities.platfor_slide.metatrader4Desc2",
            "commodities.platfor_slide.metatrader4Desc3",
            "commodities.platfor_slide.metatrader4Desc4",
            "commodities.platfor_slide.metatrader4Desc5",
        ],
        icon: "/images/forex/MT4-Icon.svg",
        alt: "Comodities on MT4",
    }, */
    {
        imgBackground: "/images/forex/background-mt5.png",
        title: "forex.mt5",
        description: [
            "commodities.platfor_slide.metatrader5Desc1",
            "commodities.platfor_slide.metatrader5Desc2",
            "commodities.platfor_slide.metatrader5Desc3",
            "commodities.platfor_slide.metatrader5Desc4",
            "commodities.platfor_slide.metatrader5Desc5",
        ],
        icon: "/images/futures/MT5-Icon.svg",
        alt: "Futures on MT5",
    },
]);

let cardsSlideProtected = ref([
    {
        icon: "sync",
        title: "commodities.protectedCardTitle1",
        desc: "commodities.protectedCardDesc1",
    },
    {
        icon: "account_balance_wallet",
        title: "commodities.protectedCardTitle2",
        desc: "commodities.protectedCardDesc2",
    },
    {
        icon: "lock",
        title: "commodities.protectedCardTitle3",
        desc: "commodities.protectedCardDesc3",
    },
    {
        icon: "acute",
        title: "commodities.protectedCardTitle4",
        desc: "commodities.protectedCardDesc4",
    },
]);

</script>